import { render, staticRenderFns } from "./TypeCode.vue?vue&type=template&id=d3a65d9e&scoped=true&"
import script from "./TypeCode.vue?vue&type=script&lang=js&"
export * from "./TypeCode.vue?vue&type=script&lang=js&"
import style0 from "./TypeCode.vue?vue&type=style&index=0&id=d3a65d9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a65d9e",
  null
  
)

export default component.exports